import React from 'react';
import { FaPlus, FaYoutube, FaGoogleDrive, FaFileAlt, FaVideo, FaBook, FaTrash, FaEye, FaUsers } from 'react-icons/fa';

const AdminContentTab = ({ content, handleDeleteContent, setShowAddContent }) => (
  <div className="space-y-6">
    <div className="flex justify-between items-center">
      <h2 className="text-xl font-bold text-white">Content Management</h2>
      <button
        onClick={() => setShowAddContent(true)}
        className="px-4 py-2 bg-gradient-to-r from-[#D4AF37] to-[#FFD700] text-[#0A1929] font-bold rounded-lg flex items-center space-x-2"
        data-testid="add-content-btn"
      >
        <FaPlus /> <span>Add Content</span>
      </button>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {content.map((item) => (
        <div key={item.id} className="bg-gradient-to-br from-[#1A2942] to-[#1E3A5F] rounded-xl p-4 border border-[#2D5A8F]">
          <div className="flex items-start justify-between mb-3">
            <div className="flex items-center space-x-2">
              {item.content_type === 'youtube' && <FaYoutube className="text-red-500" />}
              {item.content_type === 'gdrive' && <FaGoogleDrive className="text-green-500" />}
              {item.content_type === 'pdf' && <FaFileAlt className="text-blue-500" />}
              {item.content_type === 'video' && <FaVideo className="text-purple-500" />}
              {item.content_type === 'ebook' && <FaBook className="text-yellow-500" />}
              {item.content_type === 'ppt' && <FaFileAlt className="text-orange-500" />}
              <span className="text-xs text-gray-400 uppercase">{item.content_type}</span>
            </div>
            <button onClick={() => handleDeleteContent(item.id)} className="text-red-400 hover:text-red-300">
              <FaTrash />
            </button>
          </div>
          <h3 className="text-white font-bold mb-2">{item.title}</h3>
          <p className="text-gray-400 text-sm mb-3 line-clamp-2">{item.description}</p>
          
          {/* Visible To Badges */}
          <div className="flex items-center space-x-1 mb-3">
            <FaUsers className="text-gray-500 text-xs" />
            <div className="flex flex-wrap gap-1">
              {(item.visible_to || []).map((role) => (
                <span key={role} className={`px-2 py-0.5 text-xs rounded-full ${
                  role === 'client' ? 'bg-green-500/20 text-green-400' :
                  role === 'advisor' ? 'bg-blue-500/20 text-blue-400' :
                  'bg-purple-500/20 text-purple-400'
                }`}>
                  {role}
                </span>
              ))}
            </div>
          </div>
          
          <div className="flex items-center justify-between text-xs">
            <span className="text-gray-500">{item.category}</span>
            <span className="text-[#FFD700]">{item.view_count || 0} views</span>
          </div>
          {item.external_url && (
            <a href={item.external_url} target="_blank" rel="noopener noreferrer" className="mt-3 block text-center py-2 bg-[#1E3A5F] hover:bg-[#2D5A8F] text-white rounded text-sm">
              <FaEye className="inline mr-2" /> View Content
            </a>
          )}
        </div>
      ))}
      {content.length === 0 && (
        <p className="text-gray-400 text-center py-8 col-span-3">No content added yet</p>
      )}
    </div>
  </div>
);

export default AdminContentTab;
